module.exports = __webpack_public_path__ + "static/media/price.a301e038.svg";